<template>
  <div class="eBook-page">
    <header>
      <div class="top-bar">
        <img
          src="@/assets/jkt/logoJKT.png"
          alt="JKT Logo"
          class="logo"
        >
        <div class="nav-links">
          <RouterLink
            to="/"
            exact-active-class="active"
          >
            <i class="fas fa-chart-bar" /> UTAMA
          </RouterLink>
          <!--
            <RouterLink
            to="/login"
            exact-active-class="active"
            >
            <i class="fas fa-circle-user" /> LOG MASUK
            </RouterLink> 
          -->
        </div>
      </div>
      <div class="welcome-text">
        <h1>JKTGATEWAY E-BOOK</h1>
        <hr class="underline">
      </div>
    </header>
    <div
      id="gallery"
      class="gallery"
    >
      <div class="image-card">
        <img
          src="@/pages/Books/img/one.png"
          alt=""
          class="image-inner1"
        >
        <div class="image-info">
          <h5 class="title">
            PIHAK BERKUASA TEMPATAN (PBT)
          </h5>    
          <p>RUJUKAN RINGKAS MENGENAI DASAR-DASAR BERKAITAN</p>
          <p>JABATAN KERAJAAN TEMPATAN ARAS 26-29, NO 51 PERSIARAN PERDANA PRESINT 4 621000 W.P, PUTRA JAYA MALAYSIA</p>
          <p>EDISI 2023</p>
        </div>
        <div class="button-container">
          <button 
            class="download-button" 
            @click="downloadPDF('/jkt/29052023_RUJUKAN_RINGKAS_MENGENAI_DASAR_DASAR_BERKAITAN_PBT.pdf', '29052023_RUJUKAN_RINGKAS_MENGENAI_DASAR_DASAR_BERKAITAN_PBT.pdf')"
          >
            Muat Turun PDF
          </button>
          <button 
            class="download-button" 
            @click="openPDF('https://heyzine.com/flip-book/de580e1f39.html')"
          >
            Buka PDF
          </button>
        </div>
      </div>

      
      <div class="image-card">
        <img
          src="@/pages/Books/img/osc.jpg"
          alt=""
          class="image-inner"
        >
        <div class="image-info">
          <h5 class="title">
            OSC 3.0 PLUS
          </h5>       
          <p>
            MANUAL OSC 3.0 PLUS
            PROSES DAN PROSEDUR
            CADANGAN PEMAJUAN SERTA
            PELAKSANAAN PUSAT SETEMPAT (OSC)
          </p>
          <p>EDISI PERTAMA 2019</p>
        </div>
        <div class="button-container">
          <button 
            class="download-button" 
            @click="downloadPDF('/jkt/Manual OSC 3.0 Plus Cetakan Kedua Jun 2020.pdf', 'Manual OSC 3.0 Plus Cetakan Kedua Jun 2020.pdf')"
          >
            Muat Turun PDF
          </button>
          <button 
            class="download-button" 
            @click="openPDF('https://heyzine.com/flip-book/31c6e9b23b.html')"
          >
            Buka PDF
          </button>
        </div>
      </div>

      <div class="image-card">
        <img
          src="@/pages/Books/img/three.png"
          alt=""
          class="image-inner2"
        >
        <div class="image-info">
          <h5 class="title">
            AKAN DATANG
          </h5>
        </div>
        <div class="button-container">
          <button class="download-button">
            Muat Turun PDF
          </button>
          <button class="download-button">
            Buka PDF
          </button>
        </div>
      </div>
    </div>
  </div>
  <Menu />
</template>

<script setup>
import Menu from '@/components/menu-items/utama-menu.vue'

const openPDF = pdfUrl => {
  window.open(pdfUrl, '_blank')
}

const downloadPDF = (fileUrl, fileName) => {
  const link = document.createElement('a')

  link.href = fileUrl
  link.setAttribute('download', fileName || 'document.pdf')
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})
</script>



<style scoped>
.eBook-page {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-attachment: fixed;
  background-image: url("@/assets/jkt/eBookBack.png");
  background-position: center;
  background-size: cover;
  color: white;
  min-block-size: 100vh;
}

header {
  z-index: 2;
  padding: 10px;
  inline-size: 100%;
}

.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-block: 10px;
  padding-inline: 20px;
}

.logo {
  block-size: 30px;
}

.nav-links {
  display: flex;
  gap: 20px;
}

.nav-links a {
  color: #312867;
  font-size: 1rem;
  text-decoration: none;
}

.nav-links a:hover {
  text-decoration: underline;
}

.welcome-text {
  margin-block-start: 40px;
  text-align: center;
}

.welcome-text h1 {
  color: #312867;
  font-size: 64px;
  font-weight: bold;
  text-shadow: 0px 12px 4px rgba(0, 0, 0, 0.25);
}

.gallery {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  padding: 20px;
  gap: 90px;
}

.image-card {
  background: white;
  color: #312867;
  border-radius: 10px;
  padding: 15px;
  margin: 10px;
  width: 300px;
  box-shadow: 20px 25px 4px rgba(0, 0, 0, 0.25);
  position: relative;
}

.image-inner1 {
  max-inline-size: 100%;
  border-radius: 10px;
  margin-bottom: 100px;
}

.image-inner2 {
  max-inline-size: 100%;
  border-radius: 10px;
  margin-bottom: 260px;
}

.image-inner {
  max-inline-size: 100%;
  border-radius: 10px;
  margin-bottom: 20px;
}

.image-info {
  margin-top: 40px;
  text-align: center;
}

.image-info h5 {
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  color: #000;
}

.image-info p {
  margin: 5px 0;
  font-size: 16px;
  text-align: left;
  color: #000;
  font-family: Inter;
}

.button-container {
  display: flex;
  gap: 10px;  /* Adjust spacing between buttons */
  justify-content: center; /* Center buttons horizontally */
  margin-top: 20px;
}

.download-button {
  flex: 1; /* Make both buttons same size */
  background-color: #2f5596;
  color: white;
  border: none;
  padding: 10px 0;
  cursor: pointer;
  border-radius: 5px;
  transition: background-color 0.3s;
  text-align: center;
}

.download-button:hover {
  background-color: #1d3b70;
}


.download-button:hover {
  background-color: #1d3b70;
}

@media (max-width: 768px) {
  .welcome-text h1 {
    font-size: 3rem;
  }

  .nav-links {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .nav-links a {
    font-size: 0.9rem;
  }

  h1 {
    font-size: 1.5rem;
  }

  .gallery {
    flex-direction: column;
    align-items: center;
  }

  .image-card {
    width: 90%;
    margin-inline: auto;
  }
}

@media (max-width: 480px) {
  .nav-links {
    flex-direction: column;
    align-items: flex-start;
  }

  .nav-links a {
    font-size: 0.8rem;
  }

  .welcome-text h1 {
    font-size: 2.5rem;
  }

  .logo {
    block-size: 25px;
  }
}
</style>
